module.exports = __webpack_public_path__ + "static/media/altadis.f8e2730f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/altadis.png
// module id = 362
// module chunks = 0